import { z } from "zod";
import { storableText } from "./appointments";
import { partyKind, recordId } from "./contracts";
import { emailAddress, SETTINGS_NAME_MAX_LENGTH, SETTINGS_SHORT_TEXT_MAX_LENGTH } from "./organization-settings";

export const signupPreflightRequest = z.object({ email: emailAddress }).strict();
export type SignupPreflightRequest = z.infer<typeof signupPreflightRequest>;

export const signupPreflight = z.discriminatedUnion("answer", [
  z.object({ answer: z.literal("invited"), invitedAs: partyKind }),
  z.object({ answer: z.literal("exists") }),
  z.object({ answer: z.literal("new") }),
]);
export type SignupPreflight = z.infer<typeof signupPreflight>;

export const signupOrganizationKind = z.enum(["customer", "vendor", "subcontractor"]);
export type SignupOrganizationKind = z.infer<typeof signupOrganizationKind>;

export const signupRequest = z
  .object({
    name: storableText(SETTINGS_NAME_MAX_LENGTH),
    phone: z.string().trim().max(SETTINGS_SHORT_TEXT_MAX_LENGTH).optional(),
    organizationKind: signupOrganizationKind,
    organizationName: storableText(SETTINGS_NAME_MAX_LENGTH),
  })
  .strict();
export type SignupRequest = z.input<typeof signupRequest>;
export type SignupDetails = z.output<typeof signupRequest>;

export const signedUp = z.object({ person: recordId, organization: recordId });
export type SignedUp = z.infer<typeof signedUp>;
